import { useState } from "react";
import { Modal, ModalBody, ModalButton, ModalFooter, ModalHeader } from "baseui/modal";
import { FormControl } from "baseui/form-control";
import { Input } from "baseui/input";
import { useUpdateTenantMutation } from "../../../services/resourceGroups/tenantApi";
import { ICompany } from "@oqdo/automationapps/Agents/Organizations/Company";
import { useReportMutationState } from "../../../hooks/useReportMutationState";

function UpdateDialog(props: { tenant: ICompany; isOpen: boolean; setIsOpen }) {
  const { tenant, isOpen, setIsOpen } = props;
  const [state, setState] = useState(tenant);
  const [update, updateResult] = useUpdateTenantMutation();
  useReportMutationState(updateResult, () => setIsOpen(false));

  const inputsValid = state.name !== "";

  const close = () => setIsOpen(false);

  const handleNameChanged = (newvalue: string) => {
    setState((prev) => {
      return {
        ...prev,
        name: newvalue,
      };
    });
  };

  const handleLogoChanged = (newvalue: string) => {
    setState((prev) => {
      return {
        ...prev,
        logo: newvalue,
      };
    });
  };

  const handleSubmit = () => {
    update({
      id: tenant.id,
      data: {
        name: state.name,
        logo: state.logo,
        externalIds: state.externalIds,
        address: state.address,
      },
    });
  };

  return (
    <>
      <Modal onClose={close} isOpen={isOpen}>
        <ModalHeader>Update Tenant</ModalHeader>
        <ModalBody>
          <FormControl label={() => "Name"} caption={() => "Enter a descriptive name for the Tenant"}>
            <Input
              value={state.name}
              onChange={(e) => {
                handleNameChanged(e.target.value);
              }}
              placeholder="Enter name ..."
              clearable
              clearOnEscape
            />
          </FormControl>
          <FormControl label={() => "Logo"} caption={() => "Enter a logo url"}>
            <Input
              value={state.logo}
              onChange={(e) => {
                handleLogoChanged(e.target.value);
              }}
              placeholder="https://someurl.com/logo.jpg"
              clearable
              clearOnEscape
            />
          </FormControl>
        </ModalBody>
        <ModalFooter>
          <ModalButton kind="tertiary" onClick={close}>
            Cancel
          </ModalButton>
          <ModalButton disabled={!inputsValid} isLoading={updateResult.isLoading} onClick={handleSubmit}>
            Okay
          </ModalButton>
        </ModalFooter>
      </Modal>
    </>
  );
}

export default UpdateDialog;
